import React, {useEffect, useState} from "react";
import {Accordion, Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {fetchBankAccounts} from "../../../../_apis/api";
import {useDispatch, useSelector} from "react-redux";
import Dropdown from "../../../primer/Dropdown";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment";
import {Popconfirm} from "antd";
import Alert from "react-bootstrap/Alert";

const BankNotifyClientModal = ({show, setShow, defaultBankSelection = "", setDefaultBankSelection}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [availableEmails, setAvailableEmails] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [selectedBankAccounts, setSelectedBankAccounts] = useState([]);
    const [previousNotifications, setPreviousNotifications] = useState([]);

    const bankAccounts = useSelector((state) => state.CASH_DATA.bankAccounts);
    const bankAccountsOptions = bankAccounts.map((bank) => {
        return {
            value: bank._id,
            label: `${bank.name} - ${bank.iban}`,
        }
    })
    const emailOptions = availableEmails.map((o) => {
        return {
            value: o,
            label: o,
        }
    })

    useEffect(() => {
        if (show) {
            dispatch(fetchBankAccounts({ company: company.id }));
            loadEmails();
            loadPreviousNotifications();
            if (defaultBankSelection) setSelectedBankAccounts([...selectedBankAccounts, defaultBankSelection]);
        } else {
            setLoading(false);
            setAvailableEmails([]);
            setSelectedBankAccounts([]);
            setSelectedEmails([]);
            setDefaultBankSelection("");
        }
    }, [show])

    const loadPreviousNotifications = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/company-bank-notifications`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setPreviousNotifications(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const loadEmails = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/emron/get-client-data`, {
            headers: { "Content-Type": "application/json" },
            params: {
                selection: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const matchingClient = res.data.data;
                let emails = [];
                if (matchingClient.email) emails.push(matchingClient.email);
                for (const cp of matchingClient.contactPoints) {
                    emails.push(cp.email);
                }
                emails = emails.filter(Boolean).filter((item, index) => emails.indexOf(item) === index);
                if (emails.length === 0) toast.warning("Δεν βρέθηκαν καταχωρημένα e-mail στην εταιρεία Emron. Παρακαλώ επικοινωνήστε με την γραμματεία.");
                setAvailableEmails(emails);
            } else {
                toast.error("Ο πελάτης δεν βρέθηκε καταχωρημένος στην εταιρεία Emron. Παρακαλώ επικοινωνήστε με την γραμματεία.");
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleNotify = () => {
        if (selectedBankAccounts.length === 0) return toast.error("Παρακαλώ επιλέξτε τουλάχιστον έναν τραπεζικό λογαριασμό.");
        if (selectedEmails.length === 0) return toast.error("Παρακαλώ επιλέξτε τουλάχιστον ένα e-mail.");
        const banksArray = selectedBankAccounts.map((b) => {
            return {
                _id: b,
                fulfilled: false,
            }
        })

        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/company-bank-notification`, {
            company: company.id,
            emailRecipients: selectedEmails,
            banksArray: banksArray,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ενέργεια.");
                setShow(false);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleCancelNotification = (notification) => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/cancel-bank-notification`, {
            company: company.id,
            notificationId: notification._id,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ενέργεια.");
                loadPreviousNotifications();
            } else {
                if (res.data?.specialCode === "1") loadPreviousNotifications();
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const isFulfilled = (not) => not.banksArray.every((obj) => obj.fulfilled === true);

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Ειδοποίηση πελάτη</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant={"secondary"} className={"mb-2"}>
                        Οι ειδοποιήσεις αποστέλλονται καθημερινά στις <strong>14:00</strong> ώστε να δίνεται η δυνατότητα τροποιήσης και ακύρωσής τους.
                        Για περισσότερες πληροφορίες σχετικά με την δρομολόγηση τους μπορείτε να πατήσετε παρακάτω το κουμπί "Προβολή ιστορικού ειδοποιήσεων".
                    </Alert>
                    <Row>
                        <Col md={6}>
                            <Dropdown
                                name={"bankAccounts"}
                                label={"Τραπεζικοί Λογαριασμοί"}
                                options={bankAccountsOptions}
                                multiSelect={true}
                                required={true}
                                defaultValue={bankAccountsOptions.filter((el) => selectedBankAccounts.includes(el.value))}
                                onChange={(e) => setSelectedBankAccounts(e.flatMap((o) => o.value))}
                            />
                        </Col>
                        <Col md={6}>
                            <Dropdown
                                name={"emails"}
                                label={"E-Mail πελάτη"}
                                options={emailOptions}
                                multiSelect={true}
                                required={true}
                                defaultValue={emailOptions.filter((el) => selectedEmails.includes(el.value))}
                                onChange={(e) => setSelectedEmails(e.flatMap((o) => o.value))}
                            />
                        </Col>
                    </Row>
                    {previousNotifications.length > 0 && (
                        <React.Fragment>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Προβολή ιστορικού ειδοποιήσεων</Accordion.Header>
                                    <Accordion.Body>
                                        <table className={"simpleClassicTable"}>
                                            <colgroup>
                                                <col span={1} style={{width: "15%"}}></col>
                                                <col span={1} style={{width: "15%"}}></col>
                                                <col span={1} style={{width: "25%"}}></col>
                                                <col span={1} style={{width: "35%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                            </colgroup>
                                            <thead>
                                            <tr>
                                                <th>Ημερομηνία Δημιουργίας</th>
                                                <th>Κατάσταση</th>
                                                <th>E-Mail</th>
                                                <th>Τραπεζικοί λογαριασμοί</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {previousNotifications.map((not, idx) => (
                                                <tr key={`prevNot-${idx}`} style={{backgroundColor: not.cancelled === true ? "#ffabab" : not.activated === true ? "lightgreen" : "lightyellow"}}>
                                                    <td>{moment(not.created_at).format("DD/MM/YYYY HH:mm:ss")}</td>
                                                    <td>{not.cancelled === true ? (
                                                        <span>Ακυρωμένη</span>
                                                    ) : isFulfilled(not) ? (
                                                        <span>Ολοκληρωμένη από πελάτη</span>
                                                    ): not.activated === true ? (
                                                        <span>Απεσταλμένη, στις {moment(not.activatedAt).format("DD/MM/YYYY HH:mm:ss")}</span>
                                                    ) : (
                                                        <span>Δρομολογημένη</span>
                                                    )}</td>
                                                    <td>{not.emailRecipients.join(", ")}</td>
                                                    <td>{bankAccountsOptions.filter((el) => not.banksArray.some((el2) => el2._id === el.value)).flatMap((o) => o.label).join(", ")}</td>
                                                    <td>{(!isFulfilled(not) && not.cancelled !== true) && (
                                                        <React.Fragment>
                                                            <Popconfirm
                                                                title={"Ακύρωση ειδοποίησης"}
                                                                description={"Είσαστε σίγουροι ότι θέλετε να ακυρώσετε αυτήν την ειδοποίηση;"}
                                                                onConfirm={() => handleCancelNotification(not)}
                                                                okText={"Ναι"}
                                                                cancelText={"Όχι"}
                                                            >
                                                                <Badge bg={"danger"} style={{cursor: "pointer"}}>Ακύρωση</Badge>
                                                            </Popconfirm>
                                                        </React.Fragment>
                                                    )}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleNotify()} disabled={selectedBankAccounts.length === 0 || selectedEmails.length === 0 || loading}>
                        Δρομολόγηση ειδοποίησης {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default BankNotifyClientModal;
